import { render } from "./Faq.vue?vue&type=template&id=7fb053e4"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=7fb053e4&lang=scss"
script.render = render

export default script